import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import { DashboardContext } from '../DashboardContext';
import { NavSections, StyledNavLinks } from './';
import styled, { css } from 'styled-components';
export const StyledSettingsNav = styled(Div)<{
  is_degraded_banner_active: boolean;
}>(({
  theme,
  is_degraded_banner_active
}) => {
  const base_gap = 53;
  const degraded_banner_gap = 32;
  const top = is_degraded_banner_active ? base_gap + degraded_banner_gap : base_gap;
  return css`
    border-right: ${theme.border};
    min-height: calc(100vh - ${top}px);
    max-height: calc(100vh - ${top}px);
    position: sticky;
    top: ${top}px;
    z-index: 10;
  `;
});
export const StyledSettingsNavHeader = styled(Div)<{
  is_degraded_banner_active: boolean;
}>(({
  theme,
  is_degraded_banner_active
}) => css`
    background-color: ${theme.colors.surface.base.surface};
    border-bottom: ${theme.border};
    position: sticky;
    top: ${is_degraded_banner_active ? '32px' : '0px'};
    z-index: 10;
  `);
const SettingsNav = () => {
  const $ = _c(22);
  const {
    is_degraded_banner_active,
    team
  } = useContext(DashboardContext);
  const plans_path = team?.type === "outpost" ? "/settings/organization/outpost/plans" : "/settings/organization/plans";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      direction: "column"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 2,
      y: 3
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavLink to="/settings/project/general"><Icon left={true} icon="settings" pointer={true} /><Text semi={true} size="m">General</Text></NavLink>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NavLink to="/settings/project/secrets"><Icon left={true} icon="key" pointer={true} /><Text semi={true} size="m">{"API Keys & Secrets"}</Text></NavLink>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavLink to="/settings/project/access"><Icon left={true} icon="group" pointer={true} /><Text semi={true} size="m">Access Control</Text></NavLink>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NavLink to="/settings/project/integrations"><Icon left={true} icon="connect" pointer={true} /><Text semi={true} size="m">Integrations</Text></NavLink>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <NavSections title="Project" collapsable={false} first={true}><StyledNavLinks>{t2}{t3}{t4}{t5}<NavLink to="/settings/project/quotas"><Icon left={true} icon="rate_limit" pointer={true} /><Text semi={true} size="m">Quotas</Text></NavLink></StyledNavLinks></NavSections>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NavLink to="/settings/organization/general"><Icon left={true} icon="settings" pointer={true} /><Text semi={true} size="m">General</Text></NavLink>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <NavLink to="/settings/organization/members"><Icon left={true} icon="group" pointer={true} /><Text semi={true} size="m">Members</Text></NavLink>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <NavLink to="/settings/organization/api-keys"><Icon left={true} icon="key" pointer={true} /><Text semi={true} size="m">API Keys</Text></NavLink>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <NavLink to="/settings/organization/billing"><Icon left={true} icon="wallet" pointer={true} /><Text semi={true} size="m">Billing</Text></NavLink>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Icon left={true} icon="checklist" pointer={true} />;
    t12 = <Text semi={true} size="m">Plans</Text>;
    $[11] = t11;
    $[12] = t12;
  } else {
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] !== plans_path) {
    t13 = <NavSections title="Organization" collapsable={false}><StyledNavLinks>{t7}{t8}{t9}{t10}<NavLink to={plans_path}>{t11}{t12}</NavLink></StyledNavLinks></NavSections>;
    $[13] = plans_path;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <NavLink to="/settings/account/profile"><Icon left={true} icon="account" pointer={true} /><Text semi={true} size="m">Profile</Text></NavLink>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <NavSections title="Account" collapsable={false}><StyledNavLinks>{t14}<NavLink to="/settings/account/keys-and-sessions"><Icon left={true} icon="key" pointer={true} /><Text semi={true} size="m">{"Keys & Sessions"}</Text></NavLink></StyledNavLinks></NavSections>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t13) {
    t16 = <Div p={t1}>{t6}{t13}{t15}</Div>;
    $[17] = t13;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== is_degraded_banner_active || $[20] !== t16) {
    t17 = <StyledSettingsNav h={100} flex={t0} is_degraded_banner_active={is_degraded_banner_active}>{t16}</StyledSettingsNav>;
    $[19] = is_degraded_banner_active;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  return t17;
};
export default SettingsNav;